<template>
  <div class="mask" v-show="visible">
    <div class="card" v-show="visible">
      <div>
        <img src="../../../assets/image/user/login.png">
        <p><strong>丰富功能，扫码即用</strong>
          <img src="../../../assets/image/user/free.png">
        </p>
      </div>
      <br>
      <div>
        <a @click="Login_Jump()" class="btn">{{login_btn}}</a>
      </div>
      <p style="margin-top: 8px">
        <!-- <a  @click="close">取消</a> -->
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    watch: {
      closed(newVal) {
        if (newVal) {
          this.visible = false;
          this.close()
        }
      }
    },
    data() {
      return {
        visible: false,
        closed: false,
        login_btn:'登录/注册',
        callback: () => {
        }
      }
    },
    mounted() {
      this.listelogininfo();
    },
    methods: {
      close() {

        this.callback && this.callback(this);
        this.$el.parentNode.removeChild(this.$el);
      },
      Login_Jump()
      {
        // let myDate = new Date();
        // let gettime = myDate.getFullYear().toString() + (myDate.getMonth() + 1).toString() + myDate.getDate().toString();

        // if(!localStorage.getItem('loginjump'))
        // {
        //   localStorage.setItem('loginjump',gettime);
        //   _hmt.push(['_trackEvent', 'Login', 'JumpLogin']);
        // }
        // else
        // {
        //   let oldtime=localStorage.getItem('loginjump');
        //   if(oldtime!=gettime)
        //   {
        //     localStorage.setItem('loginjump',gettime);
        //     _hmt.push(['_trackEvent', 'Login', 'JumpLogin']);
        //   }
        // }
        // _hmt.push(['_trackEvent', 'Login', 'JumpLogin']);

        if(this.login_btn==='刷新登录状态')
        {
          this.$messenger.addTarget(window.parent, 'parent');
          this.$messenger.targets['parent'].send("Show_Login_JumpUrl_Message");
        }
        else
        {
          window.open('https://account.5118.com/signin?status=Plug');
          this.login_btn='刷新登录状态'
          this.$messenger.addTarget(window.parent, 'parent');
          this.$messenger.targets['parent'].send("Show_Login_BtnName_Message",'刷新登录状态');
        }
      },
      listelogininfo()
      {
        this.$messenger.listen("_5118_Login_BottonName_Change", (msg) => {
          this.login_btn='刷新登录状态'
        });
      }
    }
  }
</script>

<style scoped lang="less" type="text/less">
  @import "../../../assets/style/color.less";
  @import "../../../assets/style/config.less";

  .mask {
    font-size: 14px;
    top:@header-height;
    &:after {
      height: 50%;
    }

    .card {
      background-color: white;
      width: 100%;
      margin: 0 auto;
      vertical-align: middle;
      display: inline-block;
      padding: 15px;
      .head {
        text-align: right;
        line-height: 40px;
        .close{
          display: inline-block;
          border-radius: 50%;
          width: 30px;
          height: 30px;
          background-color: #cfcfcf;
          text-align: center;
          cursor: pointer;
          span{
            position: relative;
            top: -5px;
          }
        }
      }
      p {
        text-align: center;
        line-height: 25px;
        color: @theme-color;
      }
     .btn{
       font-size: 14px;
       padding: 0 30px;
       line-height: 35px;
       &:hover{
         color: white;
       }
     }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/global/LoginBox/Main.vue